import request from "@/utils/request";
import { IEviMember } from "../model/evimember";

// 实体
export const defaultEviMemberData: IEviMember = {
  id: "0",
  group_Id: 0,
  memberName: "",
  nickName: "",
  mobile: "",
  password: "",
  salt: "",
  email: "",
  avatar: "",
  gender: 0,
  money: 0,
  score: 0,
  prevTime: null,
  loginTime: null,
  loginIP: "",
  loginFailure: 0,
  joinIP: "",
  joinTime: null,
  createTime: null,
  updateTime: null,
  token: "",
  status: "",
  verification: ""
};

export const getEviMember = (data: any) =>
  request({
    url: "/EviMember/Get",
    method: "post",
    data
  });

export const getEviMemberPageList = (data: any) =>
  request({
    url: "/EviMember/GetPageListAsync",
    method: "post",
    data
  });

export const addEviMember = (data: any) =>
  request({
    url: "/EviMember/Add",
    method: "post",
    data
  });

export const updateEviMember = (data: any) =>
  request({
    url: "/EviMember/Update",
    method: "post",
    data
  });

// params是添加到url的请求字符串中的，用于get请求。

// 而data是添加到请求体（body）中的， 用于post请求。
